import React, { useState } from "react";
import type { ChangeEvent } from "react";
import { Input } from "@/components/ui/input";
import { validateEmail } from "@/lib/utils";
import type { EmailInputProps } from "@/interfaces";
import { useAnalytics } from "@/hooks/useAnalytics";

const EmailInput = ({
  email,
  setEmail,
  error,
  setError,
  disabled = false,
}: EmailInputProps) => {
  const [isTouched, setIsTouched] = useState(false);
  const { track } = useAnalytics();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      setError(null);
      setEmail(e.target.value);
    }
  };

  const handleBlur = () => {
    if (!disabled) {
      setIsTouched(true);
      
      // Track email field blur
      try {
        const isValid = email.trim() !== '' && validateEmail(email);
        track('click_in_add_new_card', {
          field_name: 'mail',
          is_text_valid: isValid,
        });
      } catch {
        // Ignore tracking errors
      }
    }
  };

  const isInvalid = isTouched && email.trim() && !validateEmail(email);

  return (
    <div className="mt-[-1px] mb-2">
      <Input
        placeholder="Your Email"
        id="email"
        type="email"
        value={email}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={disabled}
        className={`${isInvalid ? "text-red-500" : ""} rounded-b-md`}
      />
      {error && (
        <div id="email-errors" className="text-sm text-destructive mt-1">
          {error}
        </div>
      )}
    </div>
  );
};

export default React.memo(EmailInput);
